module.exports = __webpack_public_path__ + "img/pageBanner-bookingInquiry.8d7f1999.jpg";